module.exports = __webpack_public_path__ + "img/menu-bottom-icon-double-circles.82cc613e.svg";